import styled from "styled-components";

export const Container = styled.section`

`;

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  padding: 0.5rem;
  aspect-ratio: 1;
  background-color: #ff7417;
  color: #fff;
  border-radius: 99999px;
  font-size: 1.5rem;
`;

export const Title = styled.p`
  color: #ff7417;
  font-size: 1.15rem;
  font-weight: 600;
`;

export const ContentContainer = styled.div`

`;

